// Setting
export const SWITCH_LANGUAGE = "SWITCH_LANGUAGE";

// Coupons
export const COUPON_FETCH = "COUPON_FETCH";
export const COUPON_FETCH_SUCCESS = "COUPON_FETCH_SUCCESS";

